import React from "react";
import DialogSearch from "../DialogSearch";
import TileDepartment from "../../Tile/TileDepartment";
import PropTypes from "prop-types";
import Department from "../../../Utility/Crud/Department";
import MainContext from "../../../Context/MainContext/MainContext";

export default class DialogSearchDepartment extends DialogSearch {

    static contextType = MainContext; // For legacy class components

    /**
     * Searches for dpartments by several name combinations or ID.
     *
     * @param {string} query The search query.
     * @returns A list of filtered departments.
     */
    getSearchResults(query) {
        return Department.search(this.state.data, query, true);
    }

    /**
     * Gets the data that should be used in this dialog. Data can be manually
     * passed via the data prop, otherwise it falls back to the global list.
     *
     * @returns {array}
     */
    getData() {
        if (this.props.data) {
            return this.props.data;
        } else {
            return Object.values(this.context.departmentsIndexed);
        }
    }

    /**
     * @param {object} department The department object.
     * @returns A TileDepartment component for this department.
     */
    renderTile(department) {
        return (
            <TileDepartment
                key={ department.id }
                department={ department }
            />
        );
    }
}
